export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8765.7123717e.jpg";